"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getExistingReleaseBranch;

var _range = _interopRequireDefault(require("lodash/range"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len, no-console */
function getExistingReleaseBranch(execSync, prompt) {
  var existingReleaseHotfixBranches = execSync('git branch --color=never -r | grep -E "release--|hotfix--|minor-release--"').toString().replace(/ /g, '').replace(/origin\//g, '').split('\n').filter(function (branch) {
    return branch;
  });

  if (existingReleaseHotfixBranches.length > 1) {
    var selectionMap = {};
    console.log('There is more than one release/hotfix branch present. You should clean them up. In the meantime, select the one you want:');
    console.log('\n');
    var selectionPrompt = existingReleaseHotfixBranches.map(function (branchName, index) {
      selectionMap[parseInt(index, 10)] = branchName;
      return "".concat(index, ": ").concat(branchName);
    });
    var userSelection = parseInt(prompt("".concat(selectionPrompt.join('\n'), "\nType the number and hit enter: ")), 10);

    if (!(0, _range.default)(0, existingReleaseHotfixBranches.length).includes(userSelection)) {
      console.error('You need to select an appropriate number. Try again!');
      process.exit(1);
    }

    return selectionMap[userSelection];
  }

  return existingReleaseHotfixBranches[0];
}